import { EventChannel } from '@domain/channel';
import { useGenericQuery } from '@hooks/use-generic-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants';

export const getEventChannelsQueryKey = (eventId: string) => [QUERY_KEYS.eventChannels, eventId];

const getEventChannelsByIdFetch = async (eventId: string) => {
  const url = `${import.meta.env.VITE_EVENTS_HOST}/v1/nightgraph/events/${eventId}/channels`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetChannels = ({ eventId = '', enabled = true }: { eventId?: string; enabled?: boolean }) => {
  return useGenericQuery<EventChannel[], RequestError>(
    getEventChannelsQueryKey(eventId),
    () => getEventChannelsByIdFetch(eventId),
    {
      enabled,
    }
  );
};
